/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherMoonIcon24Solid = forwardRef('WeatherMoonIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.049 4.327c.194-.475.086-.98-.196-1.325a1.197 1.197 0 0 0-1.36-.37A10.004 10.004 0 0 0 2 11.999c0 5.523 4.477 10 10 10 4.29 0 7.946-2.7 9.367-6.491a1.197 1.197 0 0 0-.37-1.36 1.309 1.309 0 0 0-1.326-.197 7.375 7.375 0 0 1-9.622-9.624Z" })));
});
